import { z } from 'zod'
import { InterestDirection } from '../../enums/interest-direction.enum'
import { DepositStatus } from '../../enums/deposit-status.enum'

export const depositDetailsResponseSchema = z.object({
  id: z.string().guid(),
  accountId: z.string().guid(),
  interestRate: z.number(),
  termMonths: z.number().int(),
  openDate: z.coerce.date(),
  maturityDate: z.coerce.date(),
  interestDirection: z.nativeEnum(InterestDirection),
  targetAccountId: z.string().guid(),
  incomeCategoryId: z.string().guid(),
  nextInterestDate: z.coerce.date().nullable(),
  nextInterestAmount: z.number(),
  status: z.nativeEnum(DepositStatus),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type DepositDetailsResponseDto = z.infer<typeof depositDetailsResponseSchema>
